<template>
  <div>
    <b-card title="Update Picklist" class="mb-4">
      <b-row>
        <b-col cols="12" style="margin-bottom: 15px;">
          <b-button variant="primary" @click="goBack()">
            <feather-icon size="1x" icon="ArrowLeftIcon" />Back to Admin Panel
          </b-button>
        </b-col>
      </b-row>
      <b-form @submit.prevent="onSubmit">
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group label="Picklist Number">
              <b-form-input v-model="form.picklistNo" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group label="Picklist Line">
              <b-form-input v-model="form.picklistLine" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group label="Order Number">
              <b-form-input v-model="form.orderNumber" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group label="Picklist Type">
              <b-form-input v-model="form.pickListType" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group label="FromBatch">
              <b-form-input v-model="form.fromBatch" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group label="To Batch">
              <b-form-input v-model="form.toBatch" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group label="Quantity">
              <b-form-input type="number" v-model="form.quantity"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group label="Unit">
              <b-form-input v-model="form.unit" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group label="PLS">
              <b-form-input v-model="updatedData.PLS" type="datetime-local" step="1" :disabled="updatedData.PLS == ''"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group label="PLE">
              <b-form-input v-model="updatedData.PLE" type="datetime-local" step="1" :disabled="updatedData.PLE == ''"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group label="BDS">
              <b-form-input v-model="updatedData.BDS" type="datetime-local" step="1" :disabled="updatedData.BDS == ''"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group label="BDE">
              <b-form-input v-model="updatedData.BDE" type="datetime-local" step="1" :disabled="updatedData.BDE == ''"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group label="RS">
              <b-form-input v-model="updatedData.RS" type="datetime-local" step="1" :disabled="updatedData.RS == ''"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group label="RE">
              <b-form-input v-model="updatedData.RE" type="datetime-local" step="1" :disabled="updatedData.RE == ''"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group label="PS">
              <b-form-input v-model="updatedData.PS" type="datetime-local" step="1" :disabled="updatedData.PS == ''"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group label="PE">
              <b-form-input v-model="updatedData.PE" type="datetime-local" step="1" :disabled="updatedData.PE == ''"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group label="STE">
              <b-form-input v-model="updatedData.STE" type="datetime-local" step="1" :disabled="updatedData.STE == ''"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group label="User">
              <b-form-input v-model="updatedData.user"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-right">
            <b-button type="submit" variant="primary">Update</b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </div>

</template>

<script>
export default {
  data() {
    return {
      form: {
        picklistNo: '',
        picklistLine: '',
        orderNumber: '',
        pickListType: '',
        fromBatch: '',
        toBatch: '',
        quantity: 0,
        unit:''
      },
      updatedData: {
        PLS: '',
        PLE: '',
        BDS: '',
        BDE: '',
        RS: '',
        RE: '',
        PS: '',
        PE: '',
        STE: '',
        user: ''
      },
    }
  },
  mounted() {
    this.getPicklist()
  },
  computed: {
    currentUser() {
      let result = {
        updater: 'system',
        userID: null
      }
      const user = this.$store.getters['auth/getActiveUser']
      if (user.props.firstName && user.props.lastName) {
        result.updater = user.props.firstName + ' ' + user.props.lastName
      }
      if (user.id) {
        result.userID = user.id
      }
      return result
    }
  },

  methods: {
    goBack() {
      window.history.back()
    },
    isValidDateString(dateString) {
      if (!dateString) return false;
      const date = new Date(dateString);
      return !isNaN(date.getTime());
    },
    getPicklist() {
      const id = this.$route.params.id
      this.$store.dispatch("picklist/getPicklistId", {id}).then((res) => {
        const props = res.props
        this.form = {
          ...res
        }
        this.updatedData.user = res.props.user || ''
        const dateFields = ['PLS','PLE','BDS','BDE','RS','RE','PS','PE','STE']
        dateFields.forEach(field => {
          if (props && props[field]) {
            const d = new Date(props[field])
            const pad = n => n < 10 ? '0' + n : n
            const formatted = d.getFullYear() + '-' + pad(d.getMonth()+1) + '-' + pad(d.getDate()) + 'T' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds()) 
            this.$set(this.updatedData, field, formatted)
          }
        })
      }).catch((err) => {
        console.error(err);
      })
    },
    onSubmit() {
      const dateFields = ['PLS','PLE','BDS','BDE','RS','RE','PS','PE','STE']
      let payload = {}
      dateFields.forEach(field => {
        if (this.updatedData && this.updatedData[field]) {
          const d = new Date(this.updatedData[field]).toISOString()
          payload[field] = d
        }
      })
      payload.user = this.updatedData.user
      payload.quantity = this.form.quantity
      payload.updater = this.currentUser.updater
      payload.userID = this.currentUser.userID
      this.$store.dispatch("admin/updateItem", {payload: payload, id: this.$route.params.id, type: 'picklist'})
      .then((res) => {
        this.$bvToast.toast("Update Picklist Success", {
          title: "Success",
          variant: "success",
          solid: true,
        });
      })
      .catch((err) => {
        console.error(err)
        this.$bvToast.toast("Update Joborder Failed", {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
      })
    }
  }
}
</script>